<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormCompany @submit="submit" :title="'Add Company'" :form="{}"></FormCompany>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormCompany from '@/views/admin/company/FormCompany'
import axios from 'axios'

export default {
  name: 'addcompany',
  components: {
    FormCompany
  },
  props: ['title'],
  methods: {
    submit (form) {
      let scope = this; 

      form.user = scope.$store.getters.currentUser.id

      axios.post(process.env.VUE_APP_API + '/company', form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/companies/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
